/* eslint-disable @typescript-eslint/no-non-null-assertion */
import * as React from 'react';
import * as d3 from 'd3';
import { intervalAndFormat } from './IntervalGuides.utils';
import { useCanvas } from '../Canvas';
export var IntervalGuides = function (_a) {
    var xScale = _a.xScale;
    var _b = useCanvas(), boundedHeight = _b.boundedHeight, boundedWidth = _b.boundedWidth;
    var intervals = intervalAndFormat(xScale.domain()).intervals;
    var hours = d3.timeHour.every(intervals);
    if (hours === null)
        return null;
    var ticks = xScale.ticks(hours);
    return (React.createElement("g", null, ticks.map(function (tick, index) {
        return ticks[index + 1] !== undefined ? (React.createElement("rect", { key: tick.getTime(), x: xScale(tick), y: 0, width: xScale(ticks[index + 1]) - xScale(ticks[index]), height: boundedHeight, fill: index % 2 === 0 ? '#f1f4f8' : '#fff' })) : (React.createElement("rect", { key: tick.getTime(), x: xScale(tick), y: 0, width: Math.abs(boundedWidth - xScale(ticks[index])), height: boundedHeight, fill: "none" }));
    })));
};
//# sourceMappingURL=IntervalGuides.js.map